export var FileType;
(function (FileType) {
    FileType["csv"] = "csv";
    FileType["txt"] = "txt";
    FileType["xls"] = "xls";
    FileType["xlsx"] = "xlsx";
})(FileType || (FileType = {}));
//# sourceMappingURL=fileType.enum.js.map